<script lang="ts">
  import type { Run } from '../../../shared/contract'
  import Sign from './Sign.svelte'
  import StatusSign from './StatusSign.svelte'
  import { runLabel } from '../tally'

  /** The difficulty stays fixed; separate slide-in plates carry the changing status. */
  let { run, ghost = false }: { run: Run; ghost?: boolean } = $props()
</script>

<li class="run {run.grade ?? 'ungraded'}" class:off={!run.open} class:ghost aria-label={runLabel(run)}>
  <span class="trail-code" aria-hidden="true"><Sign grade={run.grade} /></span>
  <span class="n">{run.name}</span>
  <span class="inserts">
    <StatusSign state={!run.open ? 'closed' : run.groomed ? 'groomed' : 'open'} compact />
  </span>
</li>

<style>
  .run { display: flex; align-items: center; gap: 6px; min-width: 0; min-height: 26px; padding-right: 4px; margin-bottom: 1px; color: #fff; background: var(--trail-face, #344a53); border-top: 1px solid #fff; font-size: 14px; }
  .green { --trail-face: #08775f; }
  .blue { --trail-face: #0875b6; }
  .black { --trail-face: #28323e; }
  .double { --trail-face: #171f29; }
  .trail-code { flex: none; align-self: stretch; width: 23px; display: flex; align-items: center; justify-content: center; background: #fff; }
  .trail-code:has(:global(.double)) { width: 27px; }
  .n { flex: 1; min-width: 0; line-height: 17px; padding: 3px 0; font-weight: 750; overflow-wrap: anywhere; }
  .inserts { display: flex; flex: none; }
  .ghost { opacity: .32; }
  :global(.board .cols) .run { min-height: 19px; font-size: 12px; break-inside: avoid; gap: 5px; }
  :global(.board .cols) .n { padding: 1px 0; line-height: 16px; }
  :global(.board.focus .cols) .run { min-height: 26px; font-size: 14px; gap: 6px; }
  :global(.board.focus .cols) .n { padding: 3px 0; line-height: 17px; }
</style>
